import { Categories } from 'emoji-picker-react';

export const UNSUPPORTED_BROWSER_EMOJI = [
  '1fae0',
  '1f972',
  '1fae2',
  '1fae3',
  '1fae1',
  '1fae5',
  '1fae8',
  '1f978',
  '1fae4',
  '1f979',
  '1fa77',
  '1fa75',
  '1fa76',
  '1faf1',
  '1faf2',
  '1faf3',
  '1faf4',
  '1faf7',
  '1faf8',
  '1f90c',
  '1faf0',
  '1faf5',
  '1faf6',
  '1fac0',
  '1fac1',
  '1fae6',
  '1f977',
  '1fac5',
  '1fac3',
  '1fac4',
  '1f9cc',
  '1fac2',
  '1face',
  '1facf',
  '1f9ac',
  '1f9a3',
  '1f9ab',
  '1f9a4',
  '1fab6',
  '1fabd',
  '1fabf',
  '1f9ad',
  '1fab8',
  '1fabc',
  '1fab2',
  '1fab3',
  '1fab0',
  '1fab1',
  '1fab7',
  '1fabb',
  '1fab4',
  '1fab9',
  '1faba',
  '1fad0',
  '1fad2',
  '1fad1',
  '1fad8',
  '1fada',
  '1fadb',
  '1fad3',
  '1fad4',
  '1fad5',
  '1fad6',
  '1fad7',
  '1f9cb',
  '1fad9',
  '1faa8',
  '1fab5',
  '1f6d6',
  '1f6dd',
  '1f6fb',
  '1f6fc',
  '1f6de',
  '1f6df',
  '1fa84',
  '1fa85',
  '1faa9',
  '1fa86',
  '1faa1',
  '1faa2',
  '1faad',
  '1fa74',
  '1faae',
  '1fa96',
  '1fa97',
  '1fa98',
  '1fa87',
  '1fa88',
  '1faab',
  '1fa99',
  '1fa83',
  '1fa9a',
  '1fa9b',
  '1fa9d',
  '1fa9c',
  '1fa7c',
  '1fa7b',
  '1f6d7',
  '1fa9e',
  '1fa9f',
  '1faa0',
  '1faa4',
  '1faa3',
  '1fae7',
  '1faa5',
  '1faa6',
  '1faac',
  '1faa7',
  '1faaa',
  '1faaf',
  '1f6dc',
  '1f7f0',
];

export const EMOJI_PICKER_CATEGORIES = [
  {
    category: Categories.SUGGESTED,
    name: 'Recently Used',
  },
  {
    category: Categories.SMILEYS_PEOPLE,
    name: 'Smileys People',
  },
  {
    category: Categories.ANIMALS_NATURE,
    name: 'Animals Nature',
  },
  {
    category: Categories.FOOD_DRINK,
    name: 'Food Drink',
  },
  {
    category: Categories.TRAVEL_PLACES,
    name: 'Travel Places',
  },
  {
    category: Categories.ACTIVITIES,
    name: 'Activities',
  },
  {
    category: Categories.OBJECTS,
    name: 'Objects',
  },
];
